import React, { useState, useEffect, useRef } from 'react';
import '../catalogue/styles.css';
import {
  Input,
  InputGroup,
  Button,
  CheckPicker,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  FlexboxGrid,
  Container,
  SelectPicker,
  Col,
  Checkbox,
  Notification,
  Message,
  useToaster
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import { Link, useNavigate } from 'react-router-dom';
import globalIP from '../../GlobelIP';
import LoadingBar from 'react-top-loading-bar';
import MenuIcon from '@rsuite/icons/Menu';
import ugr from '@/UGRoute';
import { useInView } from 'react-intersection-observer';
import ProductCard from '@/components/ProductSearchPage/ProductCard';
import AddedOnFIlter from '@/components/AddedOnFilter';
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}
const Marketing = () => {
  const ip = globalIP;

  const AddedOn = [
    'Today',
    'Yesterday',
    'This week',
    'Last week',
    'This month',
    'Last month',
    'Last 3 month',
    'Last 6 month'
  ].map(item => ({ label: item, value: item }));
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [foundProductCount, setFoundProductCount] = useState(0);
  const [selectedUpdatedDateRange, setSelectedUpdatedDateRange] = useState(null);
  const [tempSearchQuery, setTempSearchQuery] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  // Api Start
  // const [data123, setData123] = useState([]);
  const [collection, setCollection] = useState([]);
  const [matchingProductIds, setMatchingProductIds] = useState([]);

  const [loading, setLoading] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const toaster = useToaster();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    fetchDatac();
    toaster.push(
      <Message showIcon type="info">
        Select the Collection
      </Message>,
      { placement: 'topCenter' }
    );
  }, []);

  const fetchDatac = async () => {
    setProgress(30);
    try {
      // const response = await fetch(`${ip}/api/collections?populate=*`);
      const response = await fetch(`${ip}/api/collections?pagination[page]=&populate=*`);
      setProgress(60);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/collections?pagination[page]=${page}&populate=*`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.CollectionName,
          value: item.attributes.CollectionCode,
          colProducts: item.attributes.CollectionProduct.map(product => product.ColProduct)
        }));
        allData.push(...processedData);
      }

      setCollection(allData);
      setProgress(100);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const history = useNavigate();
  const [fetchedProducts, setFetchedProducts] = useState([]);
  const [fetchedProductsMeta, setFetchedProductsMeta] = useState([]);


  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(0);
  const { ref, inView } = useInView({
    rootMargin: `0px 0px ${700}px 0px`
  });
  const fetchProducts = async matchingIds => {
    setLoading(true);
    try {
      // Create an array of query parameters for each matching ID
      const productIdsQueryParam = matchingIds
        .map(id => `filters[id][$in][]=${id}`)
        .join('&');
      // Construct the API URL by appending the query parameters
      let searchQryFilter = '';
      if (searchQuery.length > 0) {
        let searchQryy = searchQuery.trim();
        const searchQry = `filters[$or][0][ProductId][$containsi]=${searchQryy}&filters[$or][1][ProductName][$containsi]=${searchQryy}`;
        searchQryFilter = `&${searchQry}`;
      }
      let datefilter = '';
      let updateddatefilter = '';
      const formatDateToISO = date => date.toISOString();
      const getFirstDayOfWeek = date => {
        const firstDay = new Date(date);
        firstDay.setDate(date.getDate() - firstDay.getDay()); // Sunday is the first day of the week
        firstDay.setHours(0, 0, 0, 0);
        return formatDateToISO(firstDay);
      };

      const getFirstDayOfMonth = date => {
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        firstDay.setHours(0, 0, 0, 0);
        return formatDateToISO(firstDay);
      };

      const getFirstDayOfLastMonth = date => {
        const firstDayOfLastMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        firstDayOfLastMonth.setHours(0, 0, 0, 0);
        return formatDateToISO(firstDayOfLastMonth);
      };

      const getLastDayOfLastMonth = date => {
        const lastDayOfLastMonth = new Date(date.getFullYear(), date.getMonth(), 0);
        lastDayOfLastMonth.setHours(23, 59, 59, 999);
        return formatDateToISO(lastDayOfLastMonth);
      };

      const getDateDaysAgo = (date, days) => {
        const result = new Date(date);
        result.setDate(date.getDate() - days);
        result.setHours(0, 0, 0, 0);
        return formatDateToISO(result);
      };

      const today = new Date();
      const startOfToday = new Date(today.setHours(0, 0, 0, 0)); // Set time to 00:00:00
      const endOfToday = new Date(); // Current time

      switch (selectedDateRange) {
        case 'Today':
          datefilter = `filters[createdAt][$gte]=${formatDateToISO(
            startOfToday
          )}&filters[createdAt][$lte]=${formatDateToISO(endOfToday)}`;
          break;

        case 'Yesterday':
          const startOfYesterday = new Date(today);
          startOfYesterday.setDate(today.getDate() - 1);
          startOfYesterday.setHours(0, 0, 0, 0); // Set to 12:00 AM of yesterday

          const endOfYesterday = new Date(today);
          endOfYesterday.setDate(today.getDate() - 1);
          endOfYesterday.setHours(23, 59, 59, 999); // Set to 11:59 PM of yesterday

          datefilter = `filters[createdAt][$gte]=${formatDateToISO(startOfYesterday)}&filters[createdAt][$lte]=${formatDateToISO(endOfYesterday)}`;
          break;

        case 'This week':
          datefilter = `filters[createdAt][$gte]=${getFirstDayOfWeek(today)}`;
          break;

        case 'Last week':
          const lastWeekStart = new Date(today);
          lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
          datefilter = `filters[createdAt][$gte]=${formatDateToISO(
            lastWeekStart
          )}&filters[createdAt][$lte]=${getFirstDayOfWeek(today)}`;
          break;

        case 'This month':
          datefilter = `filters[createdAt][$gte]=${getFirstDayOfMonth(today)}`;
          break;

        case 'Last month':
          datefilter = `filters[createdAt][$gte]=${getFirstDayOfLastMonth(
            today
          )}&filters[createdAt][$lte]=${getLastDayOfLastMonth(today)}`;
          break;

        case 'Last 3 month':
          const threeMonthsAgo = new Date(today);
          threeMonthsAgo.setMonth(today.getMonth() - 3);
          datefilter = `filters[createdAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
          break;

        case 'Last 6 month':
          const sixMonthsAgo = new Date(today);
          sixMonthsAgo.setMonth(today.getMonth() - 6);
          datefilter = `filters[createdAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
          break;

        default: // Or handle the default case as needed
          datefilter = '';
          break;
      }


      switch (selectedUpdatedDateRange) {
        case 'Today':
          updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
            startOfToday
          )}&filters[updatedAt][$lte]=${formatDateToISO(endOfToday)}`;
          break;

        case 'Yesterday':
          const startOfYesterday = new Date(today);
          startOfYesterday.setDate(today.getDate() - 1);
          startOfYesterday.setHours(0, 0, 0, 0); // Set to 12:00 AM of yesterday

          const endOfYesterday = new Date(today);
          endOfYesterday.setDate(today.getDate() - 1);
          endOfYesterday.setHours(23, 59, 59, 999); // Set to 11:59 PM of yesterday

          updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(startOfYesterday)}&filters[updatedAt][$lte]=${formatDateToISO(endOfYesterday)}`;
          break;

        case 'This week':
          updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfWeek(today)}`;
          break;

        case 'Last week':
          const lastWeekStart = new Date(today);
          lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
          updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
            lastWeekStart
          )}&filters[updatedAt][$lte]=${getFirstDayOfWeek(today)}`;
          break;

        case 'This month':
          updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfMonth(today)}`;
          break;

        case 'Last month':
          updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfLastMonth(
            today
          )}&filters[updatedAt][$lte]=${getLastDayOfLastMonth(today)}`;
          break;

        case 'Last 3 month':
          const threeMonthsAgo = new Date(today);
          threeMonthsAgo.setMonth(today.getMonth() - 3);
          updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
          break;

        case 'Last 6 month':
          const sixMonthsAgo = new Date(today);
          sixMonthsAgo.setMonth(today.getMonth() - 6);
          updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
          break;

        default: // Or handle the default case as needed
          updateddatefilter = '';
          break;
      }
      const apiUrl = `${ip}/api/products?${productIdsQueryParam}&populate=*&pagination[page]=${currentPage}&${searchQryFilter}&${datefilter}&${updateddatefilter}`;
      // Fetch data from the API
      const response = await fetch(apiUrl);
      const json = await response.json();
      setLimit(json.data.length);

      if (currentPage === 1) {
        setFetchedProducts(json.data);
        setFetchedProductsMeta(json.meta)
      } else {
        setFetchedProducts(prevData => [...prevData, ...json.data]);
      }
      // Set the fetched products
      // setFetchedProducts(json.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };


  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);

  // Debounce effect for searchQuery
  useEffect(() => {
    setCurrentPage(1);
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery + selectedDateRange + selectedUpdatedDateRange);
    }, 500); // Adjust the debounce delay as needed

    return () => clearTimeout(timer); // Cleanup the timeout if searchQuery changes before the delay
  }, [searchQuery, selectedDateRange, selectedUpdatedDateRange]);

  useEffect(() => {
    setSearchQuery('')
  }, [selectedDateRange, selectedUpdatedDateRange])
  // Effect that triggers on debouncedSearchQuery
  useEffect(() => {
    if (matchingProductIds.length > 0) {

      fetchProducts(matchingProductIds);
    } else {
      setFetchedProducts([]);
    }
    // fetchProducts(matchingProductIds); // Your data fetching function
  }, [debouncedSearchQuery]); // This effect now triggers when debouncedSearchQuery changes


  useEffect(() => {
    if (inView && limit) {
      setCurrentPage(prev => prev + 1);
    }
  }, [inView]);

  const handleCollectionChange = selectedItems => {
    const selectedValues = selectedItems;
    const matchingIds = [];
    selectedValues.forEach(value => {
      const matchingIdsForValue = collection.find(item => item.value === value)?.colProducts || [];
      matchingIds.push(...matchingIdsForValue);
    });
    setMatchingProductIds(matchingIds);
    setCurrentPage(1)
  };
  const debounceTimeout = useRef(null);

  useEffect(() => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);  // Clear previous timeout if any
    }

    // Set a new timeout to debounce the API call
    debounceTimeout.current = setTimeout(() => {
      if (matchingProductIds.length > 0) {
        fetchProducts(matchingProductIds);
      } else {
        setFetchedProducts([]);
      }
    }, 400); // 500ms debounce delay

    // Cleanup function to clear timeout when component is unmounted or dependencies change
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, [matchingProductIds, currentPage]);

  const [selectedItems, setSelectedItems] = useState([]);
  const handleCheckAll = (value, checked) => {
    if (checked) {
      setSelectedItems(fetchedProducts.map(item => item.id)); // Replace "id" with your unique identifier property
    } else {
      setSelectedItems([]);
    }
  };
  const handleCheckboxChange = (value, checked) => {
    if (checked) {
      setSelectedItems(prevSelectedItems => [...prevSelectedItems, value]);
    } else {
      setSelectedItems(prevSelectedItems => prevSelectedItems.filter(item => item !== value));
    }
  };
  const handleCartClose = () => {
    setIsCartOpen(false);
  };

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${ip}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [openMenuBar, setOpenMenuBar] = useState(false);
  return (
    <>
      <LoadingBar color="#3498ff" progress={progress} onLoaderFinished={() => setProgress(0)} />
      <Container className="main">
        <div
          style={{
            justifyContent: 'space-between',
            width: '-webkit-fill-available',
            position: 'fixed',
            height: '190px',
            background: '#fff',
            zIndex: 1
          }}
        >
          <Stack className="table-toolbar market-head" justifyContent="space-between">
            <Stack direction="column" alignItems="flex-start">
              <Stack direction="column" alignItems="flex-start">
                <Stack direction="row" alignItems="flex-start" spacing={229}>
                  <h3 className="title">E-Marketing</h3>
                  <div onClick={() => setOpenMenuBar(!openMenuBar)}>
                    <MenuIcon className="burgerMenu1" />
                    {/* <CloseIcon className='burgerMenu1'/> */}
                  </div>
                </Stack>{' '}
                <Breadcrumb>
                  <Breadcrumb.Item>
                    <Link to={`/${ugr}/dashboard`}>Home</Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>E-Marketing</Breadcrumb.Item>
                </Breadcrumb>
              </Stack>

              <Stack spacing={5} className="checkbox" style={{ marginBottom: '-12px' }}>
                <div id="custom-container" style={{ position: 'relative' }}>
                  <CheckPicker
                    data={collection}
                    placeholder="Collections"
                    onChange={selectedItems => handleCollectionChange(selectedItems)}
                    style={{ width: 200 }}
                    container={() => document.getElementById('custom-container')}
                  />
                </div>
                <Stack
                  className={openMenuBar ? 'mange-item' : 'market-search'}
                  style={{ gap: '5px' }}
                >
                  <AddedOnFIlter
                    {...{
                      showboth: 'both',
                      AddedOn,
                      selectedDateRange,
                      handleDatechange: setSelectedDateRange,
                      selectedUpdatedDateRange,
                      handleUpdatedDatechange: setSelectedUpdatedDateRange
                    }}
                  />
                </Stack>
              </Stack>
            </Stack>

            <Stack
              alignItems="flex-end"
              spacing={16}
              style={{ marginTop: '85px' }}
              className="market-search marketing-search market-search2"
            >
              <Stack spacing={10}>
                <Stack direction="row" spacing={5} className="quotation">
                  <InputGroup inside>
                    <Input
                      placeholder="Search"
                      type="text"
                      value={searchQuery}
                      onChange={value => {
                        setSearchQuery(value);
                      }}
                      className="pdt-srch"
                    />
                    <InputGroup.Addon>
                      <SearchIcon style={{ cursor: 'pointer' }} />
                    </InputGroup.Addon>
                  </InputGroup>
                </Stack>
                {fetchedProducts.length > 0 && (
                  <Checkbox
                    indeterminate={
                      selectedItems.length > 0 && selectedItems.length < fetchedProducts.length
                    }
                    checked={selectedItems.length === fetchedProducts.length}
                    onChange={handleCheckAll}
                  >
                    Select all
                  </Checkbox>
                )}
              </Stack>
            </Stack>
          </Stack>
          <Divider className="divide" style={{ marginTop: '10px' }} />
        </div>
        <div className="row" style={{ marginTop: '175px' }}>
          <Panel>
            <b>
              {matchingProductIds.length > 0 && (
                fetchedProducts.length > 0 ? (
                  `Products: ${fetchedProducts.length}/${fetchedProductsMeta?.pagination?.total}`
                ) : (
                  `Products: 0/0`
                )
              )}
            </b>
            <FlexboxGrid justify="start" style={{ textAlign: 'center' }}>
              {loading && <p>Loading...</p>}
              {Array.isArray(fetchedProducts) && fetchedProducts.length > 0 ? fetchedProducts
                .map(product => (
                  <ProductCard
                    {...{
                      item: product,
                      label,
                      // dataGrid,
                      selectedRowIds: selectedItems,
                      handleCheckboxChange,
                      selectedItems,
                      // productUpdate,
                      pid: () => {
                        history(`/${ugr}/products-create?svid=${product.id}`);
                      },
                      showCheckbox: 1, // null means no preference
                      showEditIcon: 1, // null means no preference
                      showQuickView: 0, // null means no preference,

                    }}
                  />
                )) :
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '60vh',
                    textAlign: 'center',
                    color: '#555',
                    width: "100%"
                  }}
                >
                  <h3 style={{ marginBottom: '10px', fontWeight: 600 }}>No Collection Selected</h3>
                  <p style={{ fontSize: '15px' }}>Please select a collection to view products.</p>
                </div>}
            </FlexboxGrid>

            {selectedItems.length > 0 && (
              <Notification
                type="success"
                onClose={handleCartClose}
                style={{
                  position: 'fixed',
                  top: '80%',
                  right: 20,
                  transform: 'translateY(-50%)',
                  zIndex: 9999,
                  background: 'rgb(34 171 189)',
                  color: 'white'
                }}
                className="view1"
              >
                <b style={{ color: 'white' }}>Selected Products : {selectedItems.length}</b>
                <Divider vertical />
                <Link
                  to={{
                    pathname: `/${ugr}/manage-marketing`,
                    search: `?selectedItems=${selectedItems.join(',')}`
                  }}
                >
                  <Button style={{ float: 'right', marginTop: '-7px' }} appearance="subtle" active>
                    <b>Next</b>
                  </Button>
                </Link>
              </Notification>
            )}
          </Panel>
          <Button ref={ref} style={{ visibility: 'hidden' }}></Button>
        </div>
        <Stack
          className="copyright"
          justifyContent="flex-end"
          spacing={5}
          style={{
            position: 'fixed',
            bottom: '0',
            width: '-webkit-fill-available',
            textAlign: 'center',
            backgroundColor: 'white',
            paddingRight: '16px'
          }}
        >
          <p>© All Right Reserved. Product by </p>
          <p>
            {' '}
            <a href="https://erpdaddy.com/" target="_blank">
              ERPDaddy Software Solution.
            </a>
          </p>
        </Stack>
      </Container>
    </>
  );
};
export default Marketing;
